import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ContainerSoftware"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M21 9H15V3H21V9ZM16.5 7.5H19.5V4.5H16.5V7.5Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M12.75 11.25V6.75H6.75V17.25H17.25V11.25H12.75ZM8.25 8.25H11.25V11.25H8.25V8.25ZM11.25 15.75H8.25V12.75H11.25V15.75ZM15.75 15.75H12.75V12.75H15.75V15.75Z" }, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", { d: "M19.5 21H4.5C4.10232 20.9995 3.72105 20.8414 3.43984 20.5602C3.15864 20.2789 3.00046 19.8977 3 19.5V4.5C3.00046 4.10232 3.15864 3.72105 3.43984 3.43984C3.72105 3.15864 4.10232 3.00046 4.5 3H12V4.5H4.5V19.5H19.5V12H21V19.5C20.9995 19.8977 20.8414 20.2789 20.5602 20.5602C20.2789 20.8414 19.8977 20.9995 19.5 21Z" }, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ContainerSoftware.vue"]]);
